import { render, staticRenderFns } from "./resourcedescription.vue?vue&type=template&id=96eb063c&scoped=true"
import script from "./resourcedescription.vue?vue&type=script&lang=js"
export * from "./resourcedescription.vue?vue&type=script&lang=js"
import style0 from "./resourcedescription.vue?vue&type=style&index=0&id=96eb063c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb063c",
  null
  
)

export default component.exports